import ShareMsgBase from './A_G.ShareMsgBase';

class MsgHelpClosed extends ShareMsgBase {
  /**
   * The message that is sent when you're in a context with friend but you don't send anything but you closed the game
   * @param {string} userAvatar
   * @param {function} onAllImagesReadyCallback
   */
  constructor(userAvatar, onAllImagesReadyCallback = null) {
    super(2, onAllImagesReadyCallback);

    this.bg = this._addExtImage(0, 0, 'img/Msg_Help_App_Closed.png', 0);

    const currentMaxLvl = G.saveState.getLastPassedLevelNr();

    this.needHelpTxt = new G.Text(334, 49, OMT.language.getText('I am stuck at %Level%. Let\'s play together!').replace('%Level%', currentMaxLvl), 'msg-help', 0.5, 500);
    this.add(this.needHelpTxt);

    this.lvlTxt = new G.Text(
      G.OMTsettings.elements.worldMapLvlButton.closedMsg.x,
      G.OMTsettings.elements.worldMapLvlButton.closedMsg.y,
      currentMaxLvl,
      G.OMTsettings.elements.worldMapLvlButton.closedMsg.style,
      0.5,
      G.OMTsettings.elements.worldMapLvlButton.closedMsg.height,
      G.OMTsettings.elements.worldMapLvlButton.closedMsg.height,
      false, 'center', false, true, true,
    );
    this.add(this.lvlTxt);

    if (G.OMTsettings.elements.worldMapLvlButton.closedMsg.rotation !== 0) {
      this.lvlTxt.angle = G.OMTsettings.elements.worldMapLvlButton.closedMsg.rotation;
    }

    this.avatar1 = this._addExtImage(240, 110, userAvatar, 0, 190);
  }
}

G.MsgHelpClosed = MsgHelpClosed;
